import React, { useEffect, useState, FormEvent } from "react";
import { useParams } from "react-router-dom";
import { privilegeMap } from "../types";

const ColaboratorDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [colaboratorDetails, setColaboratorDetails] = useState<any>(null);
  const [modifyPrivilege, setModifyPrivilege] = useState(false);
  const [message, setMessage] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [privilege, setPrivilege] = useState("");
  const privilegeStorage = parseInt(localStorage.getItem("privilege") || "0");
  const canModifyPermissions = privilegeStorage === 1;

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/getAdmin/${id}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setColaboratorDetails(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar detalles del colaborador:", error);
        setIsLoading(false);
      });
  }, [id, refreshTrigger]);

  const handleUpdate = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage("");
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/getAdmin/${id}/update`, {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ privilege }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Error al actualizar privilegio");

      setMessage("Privilegio actualizado correctamente.");
      setModifyPrivilege(false);
      setRefreshTrigger((prev) => prev + 1);
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  return (
    <div className="w-full px-8 flex flex-col bg-gray-100 min-h-screen">
      <div className="flex-1 overflow-y-auto py-8">
        {isLoading ? (
          <p>Cargando detalles del colaborador...</p>
        ) : colaboratorDetails ? (
          <div className="flex flex-col items-start gap-8 w-full">
            <div className="w-full flex flex-col sm:flex-row justify-between gap-4">
              <p className="font-playfair font-bold text-4xl">{colaboratorDetails.name}</p>
              <p className="font-playfair font-bold text-2xl">{privilegeMap[colaboratorDetails.privilege] || "Sin privilegio"}</p>
            </div>

            <h2 className="font-playfair font-bold text-3xl">Administrar privilegio</h2>

            <div className="w-full">
              <div className="flex flex-row justify-between px-4 sm:px-12">
                <p className="font-bold font-sourceSans">Privilegio actual:</p>
              </div>
              <div className="flex flex-row justify-between border-y border-gray-600 px-4 sm:px-12 py-2">
                <p className="font-sourceSans">{privilegeMap[colaboratorDetails.privilege] || "Sin privilegio"}</p>
              </div>
            </div>

            {canModifyPermissions && (
              <div className="w-full flex justify-end">
                <button
                  onClick={() => setModifyPrivilege(true)}
                  className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-full sm:w-1/4 shadow-lg py-2"
                >
                  Modificar privilegio
                </button>
              </div>
            )}

            {modifyPrivilege && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-[#d9d9d9] w-[90%] sm:w-2/4 h-auto p-6 rounded-lg shadow-lg relative">
                  <button className="absolute top-2 right-2 text-gray-800 text-lg" onClick={() => setModifyPrivilege(false)}>
                    x
                  </button>
                  <form onSubmit={handleUpdate} className="flex flex-col gap-4">
                    <label className="font-sourceSans">Nuevo privilegio</label>
                    <select
                      className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] w-full shadow-lg py-2"
                      value={privilege}
                      onChange={(e) => setPrivilege(e.target.value)}
                      required
                    >
                      <option value="">Selecciona un privilegio</option>
                      <option value="1">Administración general</option>
                      <option value="2">Recepción</option>
                      <option value="3">Control escolar</option>
                    </select>
                    <button type="submit" className="bg-[#1c1c2e] text-white rounded-md py-2 mt-6">
                      Actualizar privilegio
                    </button>
                  </form>
                </div>
              </div>
            )}
          </div>
        ) : (
          <p>No se encontró al colaborador.</p>
        )}
      </div>
    </div>
  );
};

export default ColaboratorDetailsPage;
